import {Component, Injector} from '@angular/core';
import {DeviceService} from "../device/device.service";
import {DeviceType} from "../model/device-type.model";
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";

@Component({
    selector: 'app-device-type',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class DeviceTypeComponent extends GeneralListComponent {

  constructor(
    injector: Injector,
    private deviceService: DeviceService
  ) {
    super(injector);
    this.showNewBtn = true;
    this.title = this.deviceService.getTranslation("DEVICE_TYPES");

    this.columns = [
      {id: 'name',label: this.deviceService.getTranslation("NAME"), type: ColumnType.Simple},
      {id: 'attributes',label: this.deviceService.getTranslation("ATTRIBUTES"), type: ColumnType.List},
      {id: 'modified',label: this.deviceService.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedBy',label: this.deviceService.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
      {id: 'action', label: 'edit', type: ColumnType.Action}
    ];
  }

  fetchItems() {
    this.deviceService.getTypes().subscribe((resp:any) => {
      if (resp) {
        this.items = resp.map(r => new DeviceType(r));
        this.dataSource.data = this.items;
      }
    })
  }

}
